import FinishGameModal from "./FinishGameModal";

export default FinishGameModal;
